module.exports = __webpack_public_path__ + "img/3.2d8b32e5.png";